<template>
	<div class="app-dialog">
		<el-dialog title="兑换金币" :visible.sync="visibleExchange" @close="closeDialog" width="600px" custom-class="dialog-exchange">
			<p>钻石可兑换金币用于购买模型</p>
			<div class="app-flex app-flex-row-evenly app-margin-top-40 app-text-center">
				<div>
					<p class="app-font-size-24 app-margin-0">拥有</p>
					<img src="../../assets/icon/diamonds-3x.png" alt />
					<p class="app-font-size-32 app-font-color-red app-margin-0">{{ moneyInfo.diamond }}钻石</p>
				</div>
				<div><img src="../../assets/icon/exchange.png" alt /></div>
				<div>
					<p class="app-font-size-24 app-margin-0">可兑换</p>
					<img src="../../assets/icon/chest-yellow-3x.png" alt />
					<p class="app-font-size-32 app-font-color-red app-margin-0">{{ moneyInfo.diamond / 10 }}金币</p>
				</div>
			</div>
			<p class="app-margin-top-30">钻石数量(10倍)</p>
			<div>
				<el-form :model="formExchange" :rules="rulesExchange" ref="formExchange">
					<el-form-item prop="price">
						<div class="app-flex app-flex-row-between">
							<el-input
								class="app-margin-right-50"
								v-model="formExchange.price"
								placeholder="请输入用多少钻石兑换金币"
								autocomplete="off"
							></el-input>
							<el-button
								type="primary"
								@click="submitExchange()"
								class=""
								:disabled="judgePrice"
							>
								兑换
							</el-button>
						</div>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import service from '../../service/finance';
import { mapState } from 'vuex';
export default {
	name: 'PersonalExchange',
	data() {
		var validatePrice = (rule, value, callback) => {
			let reg = /^[0-9]*$/;
			if (!reg.test(value)) {
				callback(new Error('请输入数字'));
			} else {
				if (Number(value) % 10 == 0 && Number(value) !== 0) {
					callback();
				} else {
					callback(new Error('充值金额只能是10的倍数'));
				}
			}
		};
		return {
			formExchange: {
				price: ''
			},
			rulesExchange: {
				price: [{ validator: validatePrice, trigger: 'blur' }]
			},
			visibleExchange: false
		};
	},
	computed: {
		...mapState({
			moneyInfo: state => state.userAccount.account,
			userInfo: state => state.userInfo.data
		}),
		judgePrice() {
			let sum = Number(this.formExchange.price);
			let diamond = Number(this.moneyInfo.diamond);
			return sum > diamond;
		}
	},
	methods: {
		showDialog() {
			this.visibleExchange = true;
		},
		submitExchange() {
			let formName = 'formExchange';
			this.$refs[formName].validate(valid => {
				if (valid) {
					service.exchangeKB(
						{
							id: this.userInfo.id,
							kbNum: Number(this.formExchange.price) / 10
						},
						res => {
							this.$message({
								message: '兑换成功!',
								type: 'success'
							});
							this.$refs[formName].resetFields();
							this.visibleExchange = false;
							this.$store.dispatch('userAccount/getUserAccount');
							this.$emit('handleExchange');
						}
					);
				} else {
					return false;
				}
			});
		},
		closeDialog() {
			this.visibleExchange = false;
		}
	}
};
</script>

<style lang="scss" scoped>
// ::v-deep .el-dialog {
// 	width: 960px;
// 	border-radius: 25px;
// 	.el-dialog__header {
// 		.el-dialog__title {
// 			font-size: 24px;
// 		}
// 		.el-dialog__close {
// 			font-size: 18px;
// 			color: #ffffff;
// 			background-color: #b1b1b1;
// 			border-radius: 50%;
// 			padding: 5px;
// 		}
// 	}
// 	.el-dialog__body {
// 		font-size: 18px;
// 		padding: 0 30px 30px;
// 		.wechat {
// 			padding-top: 40px;
// 			text-align: center;
// 			width: 328px;
// 			height: 288px;
// 			color: #6400c1;
// 			font-size: 14px;
// 			background: url(../../assets/background/wechat.png) no-repeat;
// 		}

// 		.input-exchange {
// 			.el-input__inner {
// 				border: 1px solid #c7c7c7;
// 				height: 53px;
// 				line-height: 53px;
// 			}
// 		}

// 		.el-form-item.is-error .el-input__inner,
// 		.el-form-item.is-error .el-input__inner:focus {
// 			border: 1px solid #ff0000;
// 		}
// 	}
// }
</style>
